import { ChevronDown, ChevronRight } from 'react-feather';

const OrderWarrantySection = ({
	sections,
	toggleSection,
	register,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('warrantyTab', e)}
				>
					<h2 className="title-h2">Services & Warranty </h2>
					<button>
						{sections.warrantyTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.warrantyTab && (
					<>
						<div className="new-order-form">
							<div className="field-section-full">
								<h3 className="font-bold mb-5">
									Important information
								</h3>
								<div className="w-full">
									<h3 className="font-bold mb-5">Services</h3>
									<ul className="checkbox-button-list w-full">
										<li className="checkbox-option w-full ">
											<input
												type="checkbox"
												{...register('installationFees')}
											/>
											<label htmlFor="installationFees">
												Installation Fees
											</label>
										</li>
									</ul>
								</div>
							</div>
							<div className="field-section-full">
								<h3 className="mb-3 font-bold">Warranty Information</h3>

								<ul className="w-full list-disc pl-5">
									<li>Engineer Certified</li>
									<li>1-Year Workmanship</li>
									<li>20-Year Rust Through (only on 12 gauge steel)</li>
								</ul>
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default OrderWarrantySection;
